import { GoTo } from "../../../../../components/navigation/GoTo";
import { PageMasterMode, usePageContext } from "../../../../../components/navigation/PageContext";
import { SessionMode } from "../../../../../store/session/slices";

export const MeetingPedagogyInterventionRedirection = () => {
  const pageContext = usePageContext<SessionMode.MASTER>();
  const id = pageContext?.params?.id;
  if (id) return <GoTo page={PageMasterMode.MEETING_INTERVENTION_DASHBOARD} params={{id}} />
  return  <GoTo page={PageMasterMode.MEETING_DASHBOARD} />

};